import { React, useState, useEffect } from "react";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { Box } from "@mui/system";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useMutation } from "@apollo/client";
import { useTheme } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";

import LoginImage from "../../../assets/images/delivery.png";
import AppButton from "../../base/AppButton.component";
import { InputValidation } from "../../../utils/InputValidationRegex";
import {
  LOGIN,
  LOGIN_MFA_OPTIONS,
  REQUEST_PASSWORD,
  VALIDATE_MFA_LOGIN,
} from "../../../graphql/mutation/mutation";
import { useAuth } from "../../../context/Auth.context";

import {
  boxChild,
  signIn,
  forgetPassword,
  formControl,
  details,
} from "./Login.style";
import HocPopup from "../../../hoc/hocPopup";
import InformationDialog from "../../base/dialog-body/Information.dialog";
import { TYPE } from "../../../utils/Utils";
import SelectMFAComponent from "./SelectMfa.component";
import MfaOTPComponent from "./MfaOTP.component";

const LoginComponent = ({ dialog }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const auth = useAuth();
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    showPassword: true,
    emailError: "",
    passwordError: "",
  });
  const [loginDevices, setLoginDevices] = useState("");

  const [selectedMfaOption, setSelectedMfaOption] = useState("");
  const [isValidate, setValidate] = useState(null);
  const [selectedOtp, setSelectedOtp] = useState("");
  const [wrongotp, setWrongOtp] = useState(false);
  const userAgent = window.navigator.userAgent;
  console.log("userAgent", userAgent);

  useEffect(() => {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    setLoginDevices(isMobile ? "mobile" : "desktop");
  }, [userAgent]);
  const redirectPath = location.state?.path || "/";

  const [fetchLogin, { loading, data }] = useMutation(LOGIN, {
    onError: (err) => {
      console.log(err);
    },
    onCompleted: async (user) => {
      console.log("componentt", user.login);
      if (user?.login?.role === "admin" || user?.login?.is_mfa === false) {
        if (user.login) {
          user.login.loggedInAs = user.login.role;
        }
        sessionStorage.removeItem("groupDashboardRedirected");
        sessionStorage.removeItem("navigatedToHome");
        auth.login(user?.login);
        navigate(redirectPath, {
          replace: true,
        });
      }
      if (user?.login?.errors && user?.login?.errors[0]?.message) {
        console.log("componentt2222", user.login);
        setLoginForm({
          ...loginForm,
          passwordError: user.login.errors[0].message,
        });
      }
    },
  });
  console.log("logindata", data);
  const [
    requestPassword,
    { loading: requestingPassword, data: PasswordRequested },
  ] = useMutation(REQUEST_PASSWORD);

  const [selectMfaOption, { loading: mfaLoading, data: selectedMFAResponse }] =
    useMutation(LOGIN_MFA_OPTIONS);
  console.log(
    "selectedMFAResponse",
    selectedMFAResponse?.loginMfaOptions?.status
  );
  const [otp, setOtp] = useState(false);
  const [submittedOtp, { loading: otpLoading, data: submittedOtpResponse }] =
    useMutation(VALIDATE_MFA_LOGIN, {
      onCompleted: (submit) => {
        console.log("submitt", submit);
        if (
          submit?.validateMfaLogin?.errors &&
          submit?.validateMfaLogin?.errors[0]?.message === "Invalid OTP"
        ) {
          setLoginForm({
            ...loginForm,
            emailError: "Invalid OTP",
          });
          setOtp(!otp);
        } else {
          submit.validateMfaLogin.loggedInAs = submit.validateMfaLogin.role;
          sessionStorage.removeItem("groupDashboardRedirected");
          sessionStorage.removeItem("navigatedToHome");
          auth.login(submit.validateMfaLogin);
          navigate(redirectPath, {
            replace: true,
          });
          sessionStorage.setItem("jwt_token", submit.validateMfaLogin.token);
        }
      },
    });

  const handleLogin = () => {
    fetchLogin({
      variables: {
        loginInput: {
          email: loginForm.email,
          password: loginForm.password,
          loginDevice: loginDevices,
        },
      },
    });
    // if (
    //   (loginForm.email === "admin@echeck.com" &&
    //     loginForm.password === "Admin@1") ||
    //   (loginForm.email === "Admin@echeck.com" &&
    //     loginForm.password === "Admin@1")
    //   //    ||
    //   // (loginForm.email === "ftl@echeck.com" && loginForm.password === "Admin@1")
    // ) {
    //   auth.login({
    //     loggedInAs: "admin",
    //     dealership_logo:
    //       "https://s3.us-east-2.amazonaws.com/echeck.uat/app/images/dealership_logo/dealersure-logo.png",
    //     dealership_name: "Super Admin",
    //     dealership_user_id: 0, //00-Admin 01-FTL Admin
    //     errors: null,
    //     first_name: "Super",
    //     last_name: "Admin",
    //     // user_id: loginForm.email === "admin@echeck.com" ? "00" : "01",
    //   });
    //   navigate(redirectPath, {
    //     replace: true,
    //   });
    // } else {
    //   fetchLogin({
    //     variables: {
    //       loginInput: {
    //         email: loginForm.email,
    //         password: loginForm.password,
    //         loginDevice: loginDevices,
    //       },
    //     },
    //   }).then((user) => {
    //     console.log("componen", user?.data?.login);
    //   });
    // }
  };

  useEffect(() => {
    if (data && data.login) {
      let errors = data.login.errors;
      if (errors) {
        if (
          errors[0].message === "User not exists. Please enter registered email"
        ) {
          setLoginForm({
            ...loginForm,
            emailError: "User not exists. Please enter registered email",
          });
        } else if (
          errors[0].message === "Incorrect password. Please check your password"
        ) {
          setLoginForm({
            ...loginForm,
            passwordError: "Incorrect password. Please check your password",
          });
        } else if (
          errors[0].message ===
          "Dealership Deactivated. Please contact Store Owner. "
        ) {
          setLoginForm({
            ...loginForm,
            emailError: "Dealership Deactivated. Please contact Store Owner",
          });
        } else if (
          errors[0].message === "User Deactivated. Please contact Store Owner. "
        ) {
          setLoginForm({
            ...loginForm,
            emailError: "User Deactivated. Please contact Store Owner. ",
          });
        } else if (
          errors[0].message ===
          "Your password has expired. Kindly reset it by clicking on the Forgot Password link."
        ) {
          setLoginForm({
            ...loginForm,
            emailError:
              "Your password has expired. Kindly reset it by clicking on the Forgot Password link.",
          });
        } else {
          setLoginForm({
            ...loginForm,
            emailError: "Unknown exception",
          });
        }
      }
      //  else {
      //   if (submittedOtpResponse?.validateMfaLogin?.user_id && isValidate) {
      //     console.log("submittedOtpResponse", submittedOtpResponse);
      //     data.login.loggedInAs = data.login.role;
      //     auth.login(data.login);
      //     navigate(redirectPath, {
      //       replace: true,
      //     });
      //     sessionStorage.setItem("jwt_token", data.login.token);
      //   }
      // }
    }
  }, [data]);

  useEffect(() => {
    if (PasswordRequested?.requestPassword?.status) {
      dialog({
        open: true,
        bodyType: TYPE.DEFAULT,
        title: "Message sent",
        body: (
          <InformationDialog
            text={
              "Password reset link sent to your text. Please continue with the link to reset your password"
            }
          />
        ),
      });
    } else if (!PasswordRequested?.requestPassword?.status) {
      setLoginForm({
        ...loginForm,
        emailError: PasswordRequested?.requestPassword?.errors[0].message,
      });
    }
  }, [PasswordRequested]);

  const handleChange = (prop) => (event) => {
    setLoginForm({ ...loginForm, [prop]: event.target.value });
    let errorText;
    switch (prop) {
      case "email":
        if (InputValidation.emailValidation(event.target.value))
          errorText = "Invalid Email";
        if (event.target.value === "") errorText = "";
        setLoginForm({
          ...loginForm,
          email: event.target.value,
          emailError: errorText,
        });
        break;
      case "password":
        if (InputValidation.passwordValidation(event.target.value))
          errorText = "Invalid Password";
        if (event.target.value === "") errorText = "";
        setLoginForm({
          ...loginForm,
          password: event.target.value,
          passwordError: errorText,
        });
        break;
      default:
        break;
    }
  };

  const handleClickShowPassword = () => {
    setLoginForm({
      ...loginForm,
      showPassword: !loginForm.showPassword,
    });
  };

  const handleMfaOptionChange = (option) => {
    setSelectedMfaOption(option);
  };

  const mfaOptionLogin = () => {
    console.log("data?.login?.user_id", data?.login?.user_id);
    console.log(" data?.login?.dealership_id", data?.login?.dealership_id);
    console.log("selectedMfaOption", selectedMfaOption);
    console.log("loginDevices", loginDevices);
    selectMfaOption({
      variables: {
        loginMfaInput: {
          employee_user_id: data?.login?.user_id,
          dealership_id: data?.login?.dealership_id,
          mfaOption: selectedMfaOption,
          loginDevice: loginDevices,
        },
      },
    }).then((res) => {
      console.log("res", res);
      setValidate(res?.data?.loginMfaOptions?.status);
    });
  };

  const otpValidation = () => {
    console.log("data?.login?.user_id", data?.login?.user_id);
    console.log(" data?.login?.dealership_id", data?.login?.dealership_id);
    console.log("selectedMfaOption", selectedMfaOption);
    console.log("loginDevices", loginDevices);
    console.log("selectedOtp", selectedOtp);
    submittedOtp({
      variables: {
        validateInput: {
          employee_user_id: data?.login?.user_id,
          loginDevice: loginDevices,
          dealership_id: data?.login?.dealership_id,
          mfaOption: selectedMfaOption,
          otp: selectedOtp,
        },
      },
    });
  };

  console.log("data?.login?.is_mfa", data);
  console.log("isValidate", isValidate);
  const handleKeyPress = (event, type) => {
    if (event.key === "Enter") {
      if (
        !InputValidation.otpValidation(selectedOtp) &&
        isValidate &&
        selectedOtp
      ) {
        otpValidation();
      } else if (data?.login?.is_mfa && selectedMfaOption && !isValidate) {
        mfaOptionLogin();
      } else if (
        loginForm.email &&
        loginForm.password &&
        !InputValidation.emailValidation(loginForm.email) &&
        !InputValidation.passwordValidation(loginForm.password) &&
        !isValidate
      ) {
        handleLogin();
      }
    }
  };
  return (
    <>
      <Box component="form" noValidate autoComplete="off" sx={boxChild}>
        <Box
          component="img"
          sx={{
            flow: 1,
            marginBottom: "40px",
            display: "flex",
            alignSelf: "center",
          }}
          alt="Login"
          src={LoginImage}
          width={180}
        />
        <Typography variant="h6" component="div" sx={signIn}>
          Sign in to DeliveryIQ+
        </Typography>
        {isValidate ? (
          <MfaOTPComponent
            enteredOtp={setSelectedOtp}
            mfaOptionLogin={mfaOptionLogin}
            loginError={loginForm?.emailError}
            wrongOtp={setWrongOtp}
            handleOTP={otp}
            handleKeyPress={handleKeyPress}
          />
        ) : data?.login?.is_mfa ? (
          <SelectMFAComponent
            onMfaOptionChange={handleMfaOptionChange}
            handleKeyPress={handleKeyPress}
          />
        ) : (
          <>
            <Typography variant="span" component="div" sx={details(theme)}>
              Enter your details below
            </Typography>

            <FormControl sx={formControl} variant="outlined">
              <InputLabel color={loginForm.emailError ? "error" : "primary"}>
                Email Address
              </InputLabel>
              <OutlinedInput
                onKeyDown={handleKeyPress}
                label="Email Address"
                value={loginForm.email}
                onChange={handleChange("email")}
                sx={{ borderRadius: 2 }}
                error={loginForm.emailError}
              />
              <FormHelperText
                error={loginForm.emailError}
                sx={{ color: theme.palette.error.main }}
              >
                {loginForm.emailError || " "}
              </FormHelperText>
            </FormControl>
            <FormControl sx={formControl} variant="outlined">
              <InputLabel color={loginForm.emailError ? "error" : "primary"}>
                Password
              </InputLabel>
              <OutlinedInput
                onKeyDown={handleKeyPress}
                label="Password"
                type={loginForm.showPassword ? "password" : "text"}
                value={loginForm.password}
                onChange={handleChange("password")}
                sx={{ borderRadius: 2 }}
                error={loginForm.passwordError}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={(event) => event.preventDefault()}
                      edge="end"
                    >
                      {loginForm.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText
                error={loginForm.passwordError}
                sx={{ color: theme.palette.error.main }}
              >
                {loginForm.passwordError || " "}
              </FormHelperText>
            </FormControl>
            {requestingPassword ? (
              <CircularProgress sx={{ alignSelf: "center" }} />
            ) : (
              <AppButton
                variant="text"
                color="primary"
                sx={forgetPassword}
                buttonText=" Forgot Password?"
                disabled={requestingPassword}
                clickHandler={() => {
                  if (loginForm.email === "") {
                    setLoginForm({
                      ...loginForm,
                      emailError:
                        "Please enter your email address and then click on Forgot/Reset Password",
                    });
                  } else if (
                    loginForm.email !== "" ||
                    !InputValidation.emailValidation(loginForm.email)
                  ) {
                    requestPassword({
                      variables: {
                        passwordInput: {
                          email: loginForm.email,
                        },
                      },
                    });
                  }
                }}
              />
            )}
          </>
        )}

        {/* <SelectMFAComponent/> */}
        {/* <MfaOTPComponent/> */}
        <AppButton
          buttonText={data?.login?.is_mfa ? "Submit" : "Login"}
          sx={{ m: 1 }}
          loading={loading}
          disabled={
            loginForm.email === "" ||
            loginForm.password === "" ||
            InputValidation.emailValidation(loginForm.email) ||
            InputValidation.passwordValidation(loginForm.password) ||
            mfaLoading ||
            otpLoading ||
            loading ||
            (data?.login?.is_mfa && selectedMfaOption === "") ||
            wrongotp ||
            (data?.login?.is_mfa && selectedMfaOption === "" && !isValidate) ||
            InputValidation.otpValidation(selectedOtp) ||
            (data?.login?.is_mfa &&
              selectedMfaOption &&
              isValidate &&
              selectedOtp === "")
          }
          clickHandler={(event) => {
            loading
              ? event.preventDefault()
              : isValidate && data?.login?.is_mfa
              ? otpValidation()
              : data?.login?.is_mfa
              ? mfaOptionLogin()
              : handleLogin();
          }}
        ></AppButton>
      </Box>
      {/* {renderComponent()} */}
    </>
  );
};
export default HocPopup(LoginComponent);
